/** Matches `DIMENSION_DETECTION_PROMPT_MAX_LENGTH` in call-svc `dimension.dto.ts`. */
export const DIMENSION_DETECTION_PROMPT_MAX_LENGTH = 4000;

export const ENRICHED_DIMENSION_DATA_STALE_TIME = 1000 * 60 * 5; // 5 minutes
export const MAX_PAGINATION_LIMIT = 100;
export const DIMENSION_DEFINITION_LIMIT = MAX_PAGINATION_LIMIT;
export const DIMENSION_LIST_LIMIT = MAX_PAGINATION_LIMIT;
